import { DigitizedAsset } from 'editor/src/store/design/types';

import { RequestDigitizedAssetData } from 'editor/src/util/postMessages/messages';

function getUrlPath(url: string) {
  return url.split('?')[0];
}

/**
 * The stitch file (.PXF) an element was digitized to, when the new request may reuse it. Preflight re-renders a
 * stitch file at the new size and ignores the image, so an image that changed, by a recolour for one, needs a new one.
 * The paths are compared because the image URLs are signed anew.
 */
function getReusableDigitizedImageId(
  digitizedAsset: DigitizedAsset | undefined,
  requestPayload: RequestDigitizedAssetData['payload'],
): string | undefined {
  if (!digitizedAsset?.imageId) {
    return undefined;
  }

  const digitizedImageUrl = 'imageUrl' in digitizedAsset.payload ? digitizedAsset.payload.imageUrl : undefined;
  const requestedImageUrl = 'imageUrl' in requestPayload ? requestPayload.imageUrl : undefined;
  if (digitizedImageUrl && requestedImageUrl && getUrlPath(digitizedImageUrl) !== getUrlPath(requestedImageUrl)) {
    return undefined;
  }

  return digitizedAsset.imageId;
}

export default getReusableDigitizedImageId;
